import {
  PR_CHART_KEYS,
  ISSUE_CHART_KEYS,
  WORK_BREAKDOWN_CHARTS,
  MEETING_CHARTS,
  splitTime,
  DATA_POINT_KEYS,
  WORK_BREAKDOWN_STATS_CHARTS,
  COMMIT_CHART_KEYS,
  DEPLOY_CHART_KEYS,
  CFR_CHART_KEYS,
  CONTRIBUTOR_CHART_KEYS,
} from '../../../../shared/utils';
import { useMetricSidebarStore } from '../../../../hooks/useMetricSidebarStore';
import { MetricSidebar } from '../../../../charts/components/MetricSidebar';
import moment from 'moment';
import { TOTAL_COUNT_METRICS } from '../../utils/contributorList.utils';

export const MetricSidebarContainer = () => {
  const { sidebarInfo, closeSidebar } = useMetricSidebarStore();
  if (
    !sidebarInfo.isOpen ||
    (!PR_CHART_KEYS.includes(sidebarInfo.metric) &&
      !ISSUE_CHART_KEYS.includes(sidebarInfo.metric) &&
      !WORK_BREAKDOWN_CHARTS.includes(sidebarInfo.metric) &&
      !WORK_BREAKDOWN_STATS_CHARTS.includes(sidebarInfo.metric) &&
      !MEETING_CHARTS.includes(sidebarInfo.metric) &&
      !COMMIT_CHART_KEYS.includes(sidebarInfo.metric) &&
      !DEPLOY_CHART_KEYS.includes(sidebarInfo.metric) &&
      !CFR_CHART_KEYS.includes(sidebarInfo.metric) &&
      !DATA_POINT_KEYS.includes(sidebarInfo.metric) &&
      !CONTRIBUTOR_CHART_KEYS.includes(sidebarInfo.metric))
  ) {
    return null;
  }
  return (
    <MetricSidebar
      openDrawer={sidebarInfo.isOpen}
      handleDrawerClose={closeSidebar}
      heading={sidebarInfo.title}
      selectedTeam={sidebarInfo.teamId}
      subHeading={`${moment(sidebarInfo.startDate).format('DD MMM')} - ${moment(
        sidebarInfo.endDate
      ).format('DD MMM')}${
        [
          'PICKUP_CYCLE_TIME',
          'PR_CYCLE_TIME',
          'MERGE_CYCLE_TIME',
          'CODING_CYCLE_TIME',
          'MEETING_TIME',
          'MEAN_TIME_TO_RECOVERY',
          'LEAD_TIME_FOR_CHANGE',
        ].includes(sidebarInfo.metric)
          ? `, ${
              sidebarInfo.subTitle ? `, ${sidebarInfo.subTitle}` : ' '
            } (${splitTime(
              (sidebarInfo.data?.count || sidebarInfo.data?.y || 0) / 60
            )?.trim()})`
          : TOTAL_COUNT_METRICS.includes(sidebarInfo.metric)
          ? ` (${sidebarInfo.data?.totalCount || sidebarInfo.data?.y || 0})`
          : `${sidebarInfo.subTitle ? `, ${sidebarInfo.subTitle}` : ' '} (${
              sidebarInfo.data?.count || sidebarInfo.data?.y || 0
            })`
      }`}
      payload={{
        payload: {
          startDate: sidebarInfo.startDate,
          endDate: sidebarInfo.endDate,
        },
      }}
      currentChartMeta={{
        chartKey:
          sidebarInfo.metric === 'CUSTOM'
            ? sidebarInfo.title
            : sidebarInfo.metric,
      }}
      filterBy={{
        author: sidebarInfo.author,
        teamId: sidebarInfo.teamId,
        sprintId: sidebarInfo.sprintId,
        view: sidebarInfo.view,
        type: sidebarInfo.type,
      }}
    />
  );
};
